import type { ButtonHTMLAttributes, ReactNode } from "react"
import { Sparkles } from "lucide-react"
import { cn } from "@/lib/cn"

// The single Forge-branded CTA. Any "Discuss / Fix / Design with Forge"
// surface should mount this so the gold treatment stays consistent across
// the app. Visual styling lives in app/javascript/styles/app.css under
// .forge-button (+ .forge-button-sm for compact).

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  size?: "sm" | "md"
  /** Override the default ✨ sparkle icon (lucide). Pass null to hide. */
  icon?: ReactNode | null
  children: ReactNode
}

export function ForgeButton({ size = "md", icon, className, children, type = "button", ...rest }: Props) {
  const showIcon = icon !== null
  const iconNode = icon ?? <Sparkles size={size === "sm" ? 14 : 18} strokeWidth={2} />

  return (
    <button
      type={type}
      {...rest}
      className={cn(
        "forge-button",
        size === "sm" && "forge-button-sm",
        className,
      )}
    >
      {showIcon && (
        <span className="forge-icon" aria-hidden>{iconNode}</span>
      )}
      <span>{children}</span>
    </button>
  )
}
